import { AssetContentTypeEnum } from 'src/graphql/schema';

export const contentTypeMap = {
  unlabeled: 'Unlabeled',
  [AssetContentTypeEnum.SourceCode]: 'Source code',
  [AssetContentTypeEnum.Documentation]: 'Documentation',
  [AssetContentTypeEnum.Data]: 'Data',
} as const;
